import React, { useEffect, useState, useRef } from 'react';
import brandGlobal from '../../assets/images/brand/brand_global.png';

const BrandGlobal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.05,
        rootMargin: '-20px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className=" w-full flex justify-center bg-[#FDF4FF] py-[100px] md:py-[180px]">
      <div className="w-full flex flex-col-reverse md:flex-row items-center justify-between">
        {/* 왼쪽 이미지 */}
        <div 
          className={`w-full pt-[50px] md:pt-[0px] md:w-1/2 flex justify-center md:justify-end items-center mb-[5px] md:mb-0 mt-[5px] md:mt-0 transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <img
            src={brandGlobal}
            alt="글로벌 브랜드 이미지"
            className="w-[340px] md:w-[640px] h-[174px] md:h-[328px] object-cover"
          />
        </div>
        {/* 오른쪽 텍스트 */}
        <div 
          className={`w-full md:w-1/2 flex flex-col justify-center items-center md:items-start px-4 md:px-[120px] space-y-[16px] md:space-y-[50px] transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
          <div className="text-[#A019B2] text-[18px] md:text-[24px] leading-[160%] font-pretendard font-normal text-center md:text-left mb-4 md:mb-0">
            해외 시장을 겨냥한 글로벌 지원
          </div>
          <h2 className="text-[24px] md:text-[40px] leading-[140%] font-pretendard font-bold text-black text-center md:text-left">
            K-렌즈를 세계로,<br />글로벌로 나아가는 플랫폼
          </h2>
          <p className="text-[16px] md:text-[20px] leading-[160%] font-pretendard font-normal text-black text-center md:text-left">
            한국뿐 아니라 글로벌 고객을 위한<br />다국어 기반 B2C 플랫폼을 운영 중입니다.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BrandGlobal; 